import uniqBy from "lodash.uniqby";
import React, { Dispatch, useMemo } from "react";
import { useImmer } from "use-immer";

import { IgButton } from "@intelligems/ig-theme";
import {
  StripeApiProductDto,
  StripeApiSubscriptionItemPairDto,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { ChooseProductField } from "@src/features/admin/components/Fields/ChooseProductField";
import { ProductAccordion } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/ProductsTab/ProductAccordion";

import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "../subscriptionReducer";

interface ChooseSubscriptionProps {
  index: number;
  setPhase?: Dispatch<CreateSubscriptionReducerAction>;
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}

export const ChooseProducts = ({
  index,
  payload,
  dispatchPayload,
  setPhase,
}: ChooseSubscriptionProps) => {
  const [product, setProduct] = useImmer<StripeApiProductDto | null>(null);

  const data = useMemo(() => {
    if (!payload.phases[payload.phaseIndex].items.length) {
      return [];
    }

    return uniqBy(
      payload.phases[payload.phaseIndex].items.filter((i) => !i.deleted),
      (_) => _.product.id
    );
    // eslint-disable-next-line react-compiler/react-compiler
  }, [payload.phases[payload.phaseIndex].items]);

  return (
    <Grid container item direction={"column"} rowSpacing={2}>
      <Grid
        container
        item
        flex={1}
        justifyContent={"space-between"}
        columnSpacing={2}
      >
        <Grid item flex={1}>
          <ChooseProductField
            orgs={payload.orgs}
            filteredIds={data.map((item) => item.product.id)}
            product={product}
            onChange={(value) => setProduct(value)}
          />
        </Grid>
        <Grid item textAlign={"end"}>
          <IgButton
            disabled={!product}
            variant={"contained"}
            onClick={() => {
              if (product) {
                dispatchPayload({ type: "addItem", value: product });
                setProduct(null);
              }
            }}
          >
            Add
          </IgButton>
        </Grid>
      </Grid>
      {data.length
        ? data.map((item: StripeApiSubscriptionItemPairDto, i) => {
            return (
              <Grid item key={`${item.product.id}-${i}`}>
                <ProductAccordion
                  price={item.price || undefined}
                  product={item.product}
                  orgs={payload.orgs}
                  dispatchPayload={dispatchPayload}
                />
              </Grid>
            );
          })
        : null}
      <Grid container item justifyContent={"end"} columnSpacing={2}>
        {setPhase ? (
          <Grid item>
            <IgButton
              variant={"text"}
              onClick={() => setPhase({ type: "setPhaseIndex", value: -1 })}
            >
              Back
            </IgButton>
          </Grid>
        ) : null}
        <Grid item>
          <IgButton
            disabled={!payload.phases[payload.phaseIndex].items.length}
            onClick={() => {
              dispatchPayload({ type: "setTabIndex", value: index + 1 });
            }}
          >
            Continue
          </IgButton>
        </Grid>
      </Grid>
    </Grid>
  );
};
